import { QueryKey } from "@tanstack/react-query";

const ROOT_KEY = "bm_calendars";

export const bookingConfigKeys = {
  calendars: (page?: number, perPage?: number, term?: string): QueryKey => [
    "calendars",
    ...(page ? [page] : []),
    ...(perPage ? [perPage] : []),
    ...(term ? [term] : [])
  ],
  profileCalendars: () => ["profileCalendars"],
  profileCalendar: (calendarId: string, filters?: any, page?: number, perPage?: number) => [
    ...bookingConfigKeys.profileCalendars(),
    calendarId.toString(),
    ...(filters ? [{ filters }] : []),
    ...(page ? [page] : []),
    ...(perPage ? [perPage] : [])
  ],
  byCalendarId: (calendarId?: string) => [ROOT_KEY, "calendar", { calendarId }],
  nominalDays: (calendarId?: string) => [ROOT_KEY, "nominalDays", { calendarId }],
  exceptionDays: (calendarId?: string) => [ROOT_KEY, "exceptionDays", { calendarId }]
};
